import {EmptyFileError, InvalidExtensionError, RecordClass, RecordFormat} from '../utils'
import _ from 'lodash/fp'
import { processPathologyFiles } from './processPathologyFiles'
import { isNonDicom, processNonDicomFiles } from './processNonDicomFiles'
import { processDicomFile } from './processDicomFile'
import { isDev } from '../utils/common'
import { isDicomDir, processDicomDirFiles } from './processDicomDirFiles'

const discardMacOSApps = files => {
  const invalidPaths = _.uniq(
    files
      .map(({ path }) => path.match(/(.*\.[aA][pP][pP]\/)Contents\/MacOS\//))
      .filter(Boolean)
      .map(([wholePath, initialPath]) => initialPath)
  )
  return files.filter(
    ({ path }) => !invalidPaths.find(invalidPath => path.indexOf(invalidPath) === 0)
  )
}

export async function* processAllFiles(dirtyFiles,includedClasses = [RecordClass.Pathology,RecordClass.Other,RecordClass.Radiology], slowMode) {
  const files = discardMacOSApps(dirtyFiles)

  let remainingNonPathologyFiles = []
  
  let processedFiles = []
  let remainingNonDicomDirFiles = []
  let hasFoundDicomDirs = false
  if(slowMode || isDev){
    yield processDicomDirFiles(files).then(([dicomRecords, remainingFilesToProcess, processedFiles]) => {
      hasFoundDicomDirs = dicomRecords.length > 0
      remainingNonDicomDirFiles = remainingFilesToProcess
      return [dicomRecords,[],[]] // do not need to return processedFiles here, 3rd parameter is to return errors
      // return [dicomRecords,[],processedFiles]
    })
  } else {
    remainingNonDicomDirFiles = files
  }

  // need to get all dicomdirs
  const dicomDirs = remainingNonDicomDirFiles.filter(isDicomDir)
  // remove dicomdirs from remainingNonDicomDirFiles
  remainingNonDicomDirFiles = remainingNonDicomDirFiles.filter(file => !dicomDirs.includes(file))

  /* eslint-disable no-restricted-syntax */
  for await (const [pathologyRecords, remainingFilesToProcess] of processPathologyFiles(remainingNonDicomDirFiles)) {
  // for await (const [pathologyRecords, remainingFilesToProcess] of processPathologyFiles(files)) {
    if (includedClasses.includes(RecordClass.Pathology)) {
      yield [pathologyRecords, []]
    }
    remainingNonPathologyFiles = remainingNonPathologyFiles.concat(remainingFilesToProcess)
  }
  if (!includedClasses.includes(RecordClass.Pathology)) {
    yield [[],_.difference(remainingNonDicomDirFiles,remainingNonPathologyFiles)]
  }

  let remainingPossibleDicomFiles = []
  /* eslint-disable no-restricted-syntax */
  for await (const [nonDicomRecords, remainingFilesToProcess] of processNonDicomFiles(
    remainingNonPathologyFiles
  )) {
    if (includedClasses.includes(RecordClass.Other)) {
      yield [nonDicomRecords, []]
    }
    remainingPossibleDicomFiles = remainingPossibleDicomFiles.concat(remainingFilesToProcess)
  }
  if (!includedClasses.includes(RecordClass.Other)) {
    yield [[], _.difference(remainingNonPathologyFiles,remainingPossibleDicomFiles)]
  }

  const [invalidNonDicomExtensions, possibleDicomFiles] = _.partition(
    isNonDicom,
    remainingPossibleDicomFiles
  )
  yield [[],invalidNonDicomExtensions]

  let invalidProcessedDicom = []
  /* eslint-disable no-await-in-loop */
  for (const possibleDicomFile of possibleDicomFiles) {
    try {
      const record = await processDicomFile(possibleDicomFile)
      yield includedClasses.includes(RecordClass.Radiology)
        ? [[record], []]
        : [[],[possibleDicomFile]]
    } catch (e) {
      yield [[],[possibleDicomFile]]
      if (e instanceof EmptyFileError) {
        invalidProcessedDicom = invalidProcessedDicom.concat(possibleDicomFile)
      }
      if (e instanceof InvalidExtensionError) {
        invalidProcessedDicom = invalidProcessedDicom.concat(possibleDicomFile)
      }
    }
  }
}
